import React from "react";
import PageLayout from "../UI/PageLayout";
import { GenericReportingDropdowns } from "../../containers/GenericReportingDropdowns";
import CompassMultiplierConfigPage from "../../containers/Settings/CompassMultiplierConfigPage";

const CompassMultiplierSettingsPage = () => {
  return (
    <PageLayout
      title="Compass Multipliers Settings"
      subTitle="Configure and manage multipliers for the Compass platform"
      dropdowns={
        <GenericReportingDropdowns
          includeDateRange={false}
          includeGranularity={false}
          includeTooltipsAndTitles={false}
          containerStyle="dropdown-container"
          renderAsButton={true}
          includeCompareDateRange={false}
          includeSingleSelectRegion={true}
        />
      }
      content={<CompassMultiplierConfigPage />}
    />
  );
};

export default CompassMultiplierSettingsPage;
